<app-preloader [windowLoad]="load"></app-preloader>

<router-outlet (activate)="onActivate($event)"></router-outlet>

<app-footer></app-footer>